export function showConfetti(): void {
  const confetti = window['confetti'];

  const count = 200;
  const defaults = {
    position: { y: 0, x: 50 }, // Random horizontal start
    gravity: 1, // Makes confetti fall naturally
    ticks: 100, // Longer duration before disappearing
    spread: 500, // Wider spread
    startVelocity: 10, // Smooth falling effect
    decay: 0.95, // Slower decay for a longer-lasting effect
    zIndex:99999999,
    shapes:['circle']
  };

  function fire(particleRatio, opts) {
    confetti(
      Object.assign({}, defaults, opts, {
        particleCount: Math.floor(count * particleRatio),
      })
    );
  }

  fire(0.2, {
    colors: ["#898DF7", "#9295F2"],
    position: { y: -5, x: 10 },
  });
  fire(0.2, {
    position: { y: -5, x: 50 },
    colors: ["#898DF7", "#9295F2"],
  });
  fire(0.2, {
    position: { y: -5, x: 90 },
    colors: ["#898DF7", "#9295F2"],
  });
  fire(0.2, {
    colors: ["#898DF7", "#9295F2"],
    position: { y: -5, x: 30 },
  });
  fire(0.2, {
    position: { y: -5, x: 70 },
    colors: ["#898DF7", "#9295F2"],
  });
}
